<template>
  <div class="select-file-estrutura">
    <h3 class="d-flex">
      Estrutura de Diretórios
      <b-button
        variant="outline-info"
        size="sm"
        class="btn-action rounded-circle ml-auto"
        @click="novoItem"
        ><font-awesome-icon icon="plus"
      /></b-button>
    </h3>
    <b-overlay variant="light" opacity=".3" blur="2px" :show="loading">
      <ul v-if="!loading">
        <li v-for="(item, key) in nivel_0" :key="key">
          <Item v-model="local_value" :item="item" />
        </li>
      </ul>
    </b-overlay>
  </div>
</template>

<script>
import Item from "./SelectFileEstrutura/Item.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: { Item },
  props: {
    value: null,
  },
  data: () => ({}),
  computed: {
    ...mapState("files", ["estrutura", "loading"]),
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
    nivel_0() {
      let itens = [];
      this.estrutura.forEach((element) => {
        if (element.file_folder_id === null) {
          itens.push(element);
        }
      });
      return itens;
    },
  },
  methods: {
    ...mapActions("files", [
      "ActionGetFilesEstrutura",
      "ActionAddFilesEstrutura",
    ]),
    novoItem() {
      this.ActionAddFilesEstrutura({});
    },
  },
  async created() {
    await this.ActionGetFilesEstrutura();
  },
};
</script>

<style lang="scss">
.select-file-estrutura {
  ul {
    list-style: none;
    padding-left: 0rem;

    ul {
      padding-left: 1.5rem;
    }
  }

  .estrutura-item {
    .item-name {
      border-bottom: 1px solid #f1f1f1;
      display: flex;
      padding: 0.1rem 0.5rem;

      > span {
        display: block;
        width: 100%;
      }

      &.active {
        background: #e4f0fb;
      }

      &:hover {
        background: #e9eaec;

        .estrutura-actions {
          opacity: 1;
          transition: all 0.3s ease-in-out;
        }
      }
    }
  }

  .btn-action {
    width: 20px;
    height: 20px;
    padding: 0;
    margin-right: 0.2rem;
  }

  .estrutura-actions {
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
}
</style>
